import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";

import { StylesPDF } from "./Styles"
import { Task } from "../../../../../Redux/tasks/slice";

// Реєструємо обидва шрифти
Font.register({
  family: "NotoSans",
  fonts: [{ src: "/Fonts/NotoSans/NotoSans-Regular.ttf" }],
});

Font.register({
  family: "NotoSans Bold",
  fonts: [{ src: "/Fonts/NotoSans/NotoSans-Bold.ttf" }],
});

Font.register({
  family: "NotoSansJP",
  fonts: [{ src: "/Fonts/NotoSansJP/NotoSansJP-Regular.ttf" }],
});

export const PDFDocument = ({
  userName,
  tasks,
  t
}: {
  userName: string;
  tasks: Task[];
  t: (key: string) => string;
  }) => {

  // Перевірка на японські символи
  const containsJapanese = (text: string) => /[\u3040-\u30ff\u4e00-\u9faf]/.test(text);

  const fontForText = (text: string) => containsJapanese(text) ? "NotoSansJP" : "NotoSans";

  const styles = StyleSheet.create({
    page: {
      backgroundColor: "#fff",
    },
    taskTitle: {
      fontSize: 18,
      textAlign: "center",
      marginTop: 30
    },
    taskDescriptionContainer: {
      maxWidth: "100%",
      paddingLeft: 16,
      paddingRight: 16,
      paddingTop: 20,
      marginTop: 30
    },
    taskDescription: {
      fontSize: 18,
      textAlign: "justify"
    },
    taskDateTime: {
      fontSize: 12,
      marginTop: 4,
    },
  });

  const cleanText = (text: string) => text.replace(/\r?\n|\r/g, " ");

  return (
      <Document>
      <Page size="A5" style={styles.page} orientation="landscape">
        {tasks.map((task) => (
          <View key={task.id || task._id}>
            <View style={StylesPDF.Header}>
              <View style={StylesPDF.Logo}>
                <Text style={StylesPDF.LogoText}>Safe</Text>
                <Text style={StylesPDF.LogoTextColor}>Tasker</Text> 
              </View>
              <Text style={StylesPDF.TaskInfoTitle}>{t("privateTraslate.PDFDownloader.TaskInfoTitle")}</Text>
            </View>
            <Text style={{ ...styles.taskTitle, fontFamily: fontForText(task.name) }}>
              {task.name}
            </Text>
            <View style={styles.taskDescriptionContainer}>
              {task.description && (
                <Text style={{ ...styles.taskDescription, fontFamily: fontForText(task.description)}} wrap={false}>
                  {cleanText(task.description)}
                </Text>
              )}
            </View>
            
            <View style={StylesPDF.ContainerData}>
              <View style={StylesPDF.SelectedContainer}>
                <Text style={StylesPDF.SelectedTitle}>{t("privateTraslate.PDFDownloader.TaskInfoDate")}</Text>
                <Text style={StylesPDF.taskDateTime}>
                  {task.date}
                </Text>
              </View>
              <View style={StylesPDF.SelectedContainer}>
                <Text style={StylesPDF.SelectedTitle}>{t("privateTraslate.PDFDownloader.TaskInfoTime")}</Text>
                <Text style={StylesPDF.taskDateTime}>
                  {task.time}
                </Text>
              </View>
              
            </View>
            
          </View>
        ))}
        <View style={StylesPDF.NameCreatorTaskContainer}>
          <Text style={StylesPDF.NameCreatorColor}>{t("privateTraslate.PDFDownloader.TaskInfoCreator")} </Text>
          <Text style={StylesPDF.NameCreatorText}>{userName}</Text>
        </View>
      </Page>
    </Document>
  );
};
